import React from 'react'
import Svg, { SvgType } from 'components/svgComponent/Svg'

export default function(props: SvgType) {
  const { iconActive } = props
  const fill = iconActive ? '#FAFAFA' : '#DEDEDE'
  const opacity = iconActive ? '1' : '0.5'

  return (
    <Svg width="22" height="22" viewBox="0 0 22 22" fill="none" {...props}>
      <g opacity={opacity}>
        {/* Clipboard body */}
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.41797 2.75C6.41797 1.73828 7.23828 0.916992 8.25 0.916992H13.75C14.7617 0.916992 15.582 1.73828 15.582 2.75H17.418C18.4297 2.75 19.25 3.57031 19.25 4.58301V18.333C19.25 19.3447 18.4297 20.167 17.418 20.167H4.58203C3.57031 20.167 2.75 19.3447 2.75 18.333V4.58301C2.75 3.57031 3.57031 2.75 4.58203 2.75H6.41797ZM8.25 2.29199V4.125H13.75V2.29199H8.25ZM4.58203 4.58301V18.333H17.418V4.58301H15.582V5.04199C15.582 5.54883 15.1719 5.95898 14.6641 5.95898H7.33594C6.82812 5.95898 6.41797 5.54883 6.41797 5.04199V4.58301H4.58203Z"
          fill={fill}
        />

        {/* Inner lines */}
        <path d="M6.875 8.25H13.75V9.625H6.875V8.25Z" fill={fill} />
        {/*<path d="M6.875 10.998H13.75V12.373H6.875V10.998Z" fill={fill} />*/}
        {/*<path d="M6.875 13.748H10.543V15.123H6.875V13.748Z" fill={fill} />*/}

        {/* JOB label */}
        <text
          x="5.8"
          y="16"
          fill={fill}
          fontSize="5.7"
          fontWeight="800"
          letterSpacing="0.2"
          fontFamily="Arial, sans-serif"
        >
          Job
        </text>
      </g>
    </Svg>
  )
}
